import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { hideDialog } from "../../../redux/guest-slices/other.slice";
import { handleCreateSubscriptionCheckout } from "../../../redux/member-slices/payment.slice";
import Icons from "../../../assets/js/Icons";
import { useExchangeRate } from "../../../hooks/useExchangeRate";

function SubscriptionCheckoutDialog() {
  const dispatch = useDispatch();
  const { format: formatLocalPrice } = useExchangeRate();

  const { data } = useSelector(
    (state) => state.otherSlice
  );

  const handleClose = () => {
    localStorage.removeItem("selectedSubscriptionPlan");
    dispatch(hideDialog());
  };

  const handleContinuePayment = async () => {
    try {
      const response = await dispatch(
        handleCreateSubscriptionCheckout({
          priceId: data?.stripePriceId,
        })
      ).unwrap();

      if (response?.checkoutUrl) {
        localStorage.removeItem(
          "selectedSubscriptionPlan"
        );

        window.location.href =
          response.checkoutUrl;
      }
    } catch (error) {
      console.error(error);
      const msg = error?.message || error?.error || "";
      if (typeof msg === "string" && msg.toLowerCase().includes("active subscription")) {
        localStorage.removeItem("selectedSubscriptionPlan");
        handleClose();
      }
    }
  };

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          Complete Your Subscription
        </Typography>

        <IconButton
          sx={{
            top: 10,
            right: 10,
            position: "absolute",
          }}
          onClick={handleClose}
        >
          <Icons.Cross />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography
          textAlign="center"
          fontSize={16}
        >
          You selected the{" "}
          <strong>
            {data?.planName}
          </strong>{" "}
          plan.
        </Typography>

        <Typography
          textAlign="center"
          mt={2}
          fontSize={16}
        >
          Billing Cycle:{" "}
          <strong>
            {data?.billingCycle}
          </strong>
        </Typography>

        <Typography
          textAlign="center"
          mt={1}
          fontSize={16}
        >
          Price:{" "}
          <strong>
            {data?.price != null ? formatLocalPrice(data?.price, "usd") : ""}
          </strong>
        </Typography>

        <Typography
          textAlign="center"
          mt={2}
          fontSize={16}
        >
          Continue to complete your
          subscription payment.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 3,
        }}
      >
        <Button
          color="inherit"
          variant="outlined"
          onClick={handleClose}
        >
          Later
        </Button>

        <Button
          color="primary"
          variant="contained"
          onClick={handleContinuePayment}
        >
          Continue Payment
        </Button>
      </DialogActions>
    </Paper>
  );
}

export default SubscriptionCheckoutDialog;